import { styled } from "@mui/material";

// Define a styled input component that is visually hidden
export const VisuallyHiddenFileInput = styled("input")({
  clip: "rect(0 0 0 0)", // Clip the element to a rectangle with zero width and height
  clipPath: "inset(50%)", // Clip the element to an inset rectangle
  height: 1, // Set the height to 1 pixel
  overflow: "hidden", // Hide any overflow
  position: "absolute", // Position the element absolutely
  bottom: 0, // Position the element at the bottom
  left: 0, // Position the element at the left
  whiteSpace: "nowrap", // Prevent text from wrapping
  width: 1, // Set the width to 1 pixel
});
